import React, { Fragment, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import LoadingButton from "@mui/lab/LoadingButton";
import { Button, Input, Modal, Stack, Typography } from "@mui/material";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/system";
import DatePicker from "@mui/lab/DatePicker";
import {
  getFacultySalaryCustomization,
  calculateSalaryForOne,
  calculateSalaryForAll
} from "./../../api/salaryApi";
import StaticSalaryForm from "./StaticSalaryForm";
import { makeStyles } from "@mui/styles";
import { ToastContainer, toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  subHeading: {
    paddingBottom: 20,
    color: "blue",
  },
}));

export default function GenerateSalary(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { salaryReducer = {} } = state;
  const {
    searchingSalarySlip,
    existingSalaryConfig = {},
    searchingUser,
  } = salaryReducer;
  const { authenticationReducer: { userProfile } = {} } = state;
  const { faculty_id } = userProfile;
  const [employeeId, setEmployeeId] = useState("");
  const [isLoadingForOne, setIsLoadingForOne] = useState("");
  const [isLoadingForAll, setIsLoadingForAll] = useState("");

  const onButtonClick = () => {
    const searchErrorCallback = () =>
      toast.error("Id not found. Please try again...", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    const salaryErrorCallback = (message) =>
      toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    const callbacks = {
      searchErrorCallback,
      salaryErrorCallback,
    };
    // verifyAndSearchUser(employeeId, callbacks);
  };
  
  const generateForOneHandler = () => {
    setIsLoadingForOne(true);
    const requestBody = {
        id: faculty_id,
        // faculty_id: employeeId,
        created_by: faculty_id
      };
      const callbacks = {
        successCallback: salaryForOneSuccessCallback,
        failureCallback: salaryForOneFailureCallback,
      };
    dispatch(calculateSalaryForOne(requestBody, callbacks));
  }
  const salaryForOneSuccessCallback = (data) => {
    console.log("data", data);
    setIsLoadingForOne(false);
    toast.success("Salary slip generated successfully.");
    // setisSalarySlip(true);
    // setSalarySlipData(data);
  };
  const salaryForOneFailureCallback = (err) => {
    // console.log("err:", err);
    setIsLoadingForOne(false);
    toast.error(err.data.error);
    // setisSalarySlip(false);
  };
 
  const generateForAllHandler = () => {
    setIsLoadingForAll(true);
    const requestBody = {
        id: faculty_id,
        // faculty_id: employeeId,
        created_by: faculty_id,
        month: moment(new Date()).format("MMM"),
        year: new Date().getFullYear()
      };
      const callbacks = {
        successCallback: salaryForAllSuccessCallback,
        failureCallback: salaryForAllFailureCallback,
      };
    dispatch(calculateSalaryForAll(requestBody, callbacks));
  }
  const salaryForAllSuccessCallback = (data) => {
    // console.log("data", data);
    setIsLoadingForAll(false);
    if(data.status) toast.success("Salary slips generated successfully for all the members.");
    // setisSalarySlip(true);
    // setSalarySlipData(data);
  };
  const salaryForAllFailureCallback = () => {
    setIsLoadingForAll(false);
    toast.error("Failed to generate salary for all.");
    // setisSalarySlip(false);
  };

  const renderHeader = () => {
    return (
      <Fragment>
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Generate Salary</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <span>St. Andrews College</span>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Generate Salary Slips
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  const renderContent = () => {
    let customClass = "";
    // if (verifyApiCalled) {
    //   if (verificationSuccess) {
    //     customClass = "success";
    //   } else {
    //     customClass = "failed";
    //   }
    // }
    return (
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">
            Generate salary slips for all the staff or for any individual
          </h3>
        </div>

        <div className="card-body">
          <div className="col-md-9 row">
            <label className="col-md-3 col-form-label">
              Enter Faculty Id<span className="text-danger">*</span>
            </label>
            <div className="col-md-6">
              <input
                type="text"
                className={`form-control ${customClass}`}
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
              />
            </div>

            {isLoadingForOne ? (
              <i
                className="fa fa-circle-o-notch fa-spin fa-fw ml-3 mt-2"
                style={{ height: "fit-content" }}
              ></i>
            ) : (
              <button
                id="search-user-btn"
                className="btn btn-primary col-md-3"
                disabled={!employeeId}
                type="button"
                onClick={generateForOneHandler}
              >
                Generate salary
              </button>
            )}
          </div>
          <div>---------------- OR ----------------</div>
          <div className="mt-10 col-md-6">
            {isLoadingForAll ? (
              <i
                className="fa fa-circle-o-notch fa-spin fa-fw ml-3 mt-2"
                style={{ height: "fit-content" }}
              ></i>
            ) : (
              <button
                id="search-user-btn"
                className="btn btn-primary col-md-6"
                type="button"
                onClick={generateForAllHandler}
              >
                Generate salary for all
              </button>
            )}
          </div>
          {/* {verificationSuccess && Object.keys(existingSalaryConfig).length > 0 && (
            <Fragment>
              <hr />
              <CreateSalaryForm
                isEdit
                userInformation={userInformation}
                verificationSuccess={verificationSuccess}
                verifyApiCalled={verifyApiCalled}
                searchingUser={searchingUser}
                existingSalaryConfig={existingSalaryConfig}
                editorId={edited_by}
                history={history}
                isUpdating={isUpdatingConfiguration}
              />
            </Fragment>
          )} */}
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      {renderHeader()}
      <div className="section-body mt-4">
        <div className="container-fluid">{renderContent()}</div>
      </div>
      <ToastContainer />
    </Fragment>
  );
}
